import React from "react";
import "./Next90Modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

const Next90Modal = ({ isOpen, onClose, setMoreNext90, saveNext90, handleNoClick }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleNavigation = () => {
    navigate('/plan-for-success/next90');
    setMoreNext90(true)
    handleNoClick()
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>NEXT 90</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        More?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={saveNext90}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #949a9e",
            color: "#949a9e",
          }}
        >
          No
        </Button>
        <Button
          variant="primary"
          onClick={handleNavigation}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d1b794",
            color: "#d1b794",
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Next90Modal;
